exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-tutorial-js": () => import("./../../../src/templates/tutorial.js" /* webpackChunkName: "component---src-templates-tutorial-js" */),
  "component---src-templates-tutorials-js": () => import("./../../../src/templates/tutorials.js" /* webpackChunkName: "component---src-templates-tutorials-js" */)
}

